import { BaseService } from './BaseService';
import { User } from './types/identity';
import axios, { AxiosResponse } from 'axios';
import { genderValidator } from '~/utils/validators';
import { Gender } from './CandidateService';

export * from './types/identity';

export default class IdentityService extends BaseService {
    constructor() {
        super('identity', true);
    }

    async getMe(): Promise<User> {
        const validateGender = (gender: Gender): Gender =>
            genderValidator(gender.toUpperCase()) ? (gender.toUpperCase() as Gender) : 'N';

        return axios({
            url: this.getUrl('user/me'),
        }).then((res: AxiosResponse<User>) => ({
            ...res.data,
            gender: validateGender(res.data.gender),
            newsLetterConsent: !!res.data.newsLetterConsent,
            firstLetterInName: !!res.data.firstName
                ? res.data.firstName.charAt(0).toUpperCase()
                : 'A',
        }));
    }

    async saveMe(data: Partial<User>) {
        return axios({
            url: this.getUrl('user/me'),
            method: 'PUT',
            data,
        }).then(this.isOK);
    }

    async saveImage(image: File) {
        const data = new FormData();
        data.append('avatar', image);

        return axios({
            url: this.getUrl('user/avatar'),
            method: 'POST',
            data,
        }).then(this.isOK);
    }
}
